import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistroRendicionComponent } from './registro-rendicion.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  imports: [
    CommonModule, RouterModule,
    ReactiveFormsModule,
    NgxCaptchaModule
  ],
  declarations: [RegistroRendicionComponent],
  exports: [RegistroRendicionComponent]
})
export class RegistroRendicionModule { }



// WEBPACK FOOTER //
// ./src/app/components/registro-rendicion/registro-rendicion.module.ts